import { query } from "../../utilities/query";
import { createAction } from "redux-actions";

export const fetchSigntask = Object.assign(
  id => dispatch => dispatch(query(fetchSigntask)(`/api/signtask/${id}`, "GET", undefined, { id })),
  {
    success: createAction("signtasks/FETCH_ONE_SUCCESS", signtask => ({ [signtask.id]: signtask })),
    failure: createAction("signtasks/FETCH_ONE_FAILURE")
  }
);
